import React from "react";
import { hot } from "react-hot-loader";

// import purple from "@material-ui/core/colors/purple";
import { BrowserRouter as Router } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import { StylesProvider } from "@material-ui/styles";
import { Layout } from "./Pages/Layout";
import { AppRoutes } from "./AppRoutes";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";
import { ThemeProvider } from "styled-components";
import { createMuiTheme } from "@material-ui/core/styles";

const defaultTheme = createMuiTheme({
	typography: {
		fontFamily: `"Roboto Condensed", "Helvetica", "Arial", sans-serif`,
		h5: {
			fontSize: "18px",
			fontWeight: "bold"
		},
		h6: {
			fontSize: "14px",
			fontWeight: "bold"
		},
		subtitle1: {
			fontSize: "14px",
			fontWeight: 300,
			lineHeight: 1.4,
			letterSpacing: "-0.4px"
		},
		subtitle2: {
			fontSize: "14px",
			fontWeight: 300
		}
	},
	palette: {
		primary: {
			main: "#9DCB3B",
			contrastText: "#FFFFFF"
		},
		secondary: {
			main: "#F2893E",
			contrastText: "#FFFFFF"
		}
	},
	overrides: {
		MuiLink: {
			root: {
				textDecoration: "none",
				color: "#000"
			}
		},
		MuiTabs: {
			indicator: {
				display: "none"
			}
		},
		MuiTab: {
			root: {
				backgroundColor: "#F1F1F1",
				border: "1px solid rgba(0, 0, 0, 0.08)",
				marginLeft: "1px",
				textTransform: "capitalize",
				fontWeight: "bold",
				borderRadius: "2px 2px 0 0",
				"&:hover": {
					backgroundColor: "rgba(0, 0, 0, .1)",
					color: "black"
				},
				"@media (min-width: 960px)": {
					width: "57px",
					minWidth: "57px"
				}
			}
		},
		MuiButton: {
			root: {
				margin: "15px 0 15px 0",
				borderRadius: "0",
				textTransform: "capitalize",
				fontSize: "16px"
			}
		},
		MuiListItemIcon: {
			root: {
				minWidth: "36px"
			}
		},
		MuiOutlinedInput: {
			input: {
				padding: "10px 6px 10px 6px",
				height: "30px"
			},
			notchedOutline: {
				borderRadius: "0"
			}
		},
		MuiInputLabel: {
			outlined: {
				fontWeight: 500,
				color: "#191919"
			}
		}
	}
});

const App: React.FC = () => {
	return (
		<StylesProvider injectFirst>
			<MuiThemeProvider theme={defaultTheme}>
				<ThemeProvider theme={defaultTheme}>
					<CssBaseline>
						<Router>
							<Layout>
								<AppRoutes />
							</Layout>
						</Router>
					</CssBaseline>
				</ThemeProvider>
			</MuiThemeProvider>
		</StylesProvider>
	);
};

export default hot(module)(App);
